import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const HotelPriceSkeleton = () => {
  return (
    <Grid
      item
      container
      xs={12}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
        justifyContent: 'flex-start',
        gap: 0.5,
      }}
    >
      {/* Bloque Precio por noche */}
      <Grid
        item
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: { xs: 'flex-start', sm: 'center' },
          paddingTop: { xs: '10px', sm: 0 },
        }}
      >
        <Skeleton
          variant="text"
          width="40%"
          height={24}
          sx={{ borderRadius: 1 }}
        />

        <Skeleton
          variant="text"
          width="25%"
          height={24}
          sx={{ borderRadius: 1 }}
        />
      </Grid>

      {/* Precio total */}
      <Skeleton variant="text" width={'65%'} height={23} sx={{ mt: 1 }} />
    </Grid>
  );
};

export default HotelPriceSkeleton;
